import React from 'react';
import { Box } from '@mui/material';
import { AnomalyCount } from '@/__generated__/graphql';
import { Bar } from '../styles';
import { POI_STATUS_COLOR_MAP } from '@/theme/colors';

const BAR_OFFSET = 0.3;

export const StackedCount = ({
  counts,
  colorMapper,
}: {
  counts: AnomalyCount[];
  colorMapper: (key: string) => string;
}) => {
  const totalCount =
    counts
      .map((damageClass) => damageClass.count)
      .reduce((accumulator, current) => {
        return (accumulator ?? 0) + (current ?? 0);
      }, 0) ?? 0;

  const barData = counts.map(({ key, count }) => ({
    name: key ?? '',
    value: count ?? 0,
    width: `calc(${((count ?? 0) / (totalCount ?? 0)) * 100}% + ${BAR_OFFSET}rem)`,
    fill: colorMapper(key ?? ''),
  }));

  const getPreviousCumulativeWidth = (index: number) => {
    return (
      (counts
        .slice(0, index)
        .map((previousEntry) => previousEntry.count)
        .reduce((accumulator, current) => {
          return (accumulator ?? 0) + (current ?? 0);
        }, 0) ?? 0) / totalCount
    );
  };

  return (
    <Box
      sx={{
        pt: '4',
        height: '1.2rem',
        width: `calc(100% - ${BAR_OFFSET}rem)`,
        position: 'relative',
      }}
    >
      {totalCount === 0 && (
        <Bar
          background={POI_STATUS_COLOR_MAP['N/A']}
          width="100%"
          offset={0}
          sx={{
            borderColor: 'rgba(222, 224, 230, 0.20)',
          }}
        />
      )}
      {totalCount > 0 &&
        barData.map((entry, index) => (
          <Bar
            key={index}
            background={entry.fill}
            width={entry.width}
            offset={getPreviousCumulativeWidth(index)}
          />
        ))}
    </Box>
  );
};
